import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import RegisterForm from 'components/auth/register-form';
import LoginForm from 'components/auth/login-form';
import FAWrapper from 'components/vendors/fa-wrapper';
import { SectionBlock, SectionTitle, SectionBody, SectionFooter } from 'components/blocks/section-blocks';
import { Container, Button, FormGroup, Label, Input } from 'reactstrap';

const ProviderFlowAuth = (props) => {
  const { session, prevAction, nextAction, nextLoginAction } = props;
  const [ showRegister, setShowRegister ] = useState(true);


	// Render
  return (
    <Container className='xs'>
      <SectionBlock>
        {showRegister ? <SectionTitle title='Register to continue'/> : <SectionTitle title='Login to continue'/>}
        <SectionBody className='basic'>
          {showRegister ? (
            <RegisterForm
              userID={session.userId}
              flow={true}
              isProviderAuth={true}
              toggleView={() => setShowRegister(!showRegister)}
              nextAction={() => nextAction()}
            />
          ) : (
            <LoginForm
              userID={session.userId}
              flow={true}
              isProviderAuth={true}
              toggleView={() => setShowRegister(!showRegister)}
              nextAction={() => nextLoginAction()}
            />
          )}
        </SectionBody>
      </SectionBlock>
    </Container>
  )
}

export default ProviderFlowAuth;
